import parse from 'html-react-parser'
import clsx from 'clsx'
import { Section } from '@/components'
import { useWindowSize } from '@/hooks'
import { getTranslatedField, type TranslatableField } from '@/libs/utils'
import type { PersonType } from '@/@types/microcms-type'

type CareerFieldProps = {
    person: PersonType['name']
    field: TranslatableField
    locale?: string
    index: number
}

const DesktopSection = ({
    field,
    locale,
    person
}: Omit<CareerFieldProps, 'index'>) => {
    return (
        <div
            key={`${person.name_ja}-${field.career_title_ja}`}
            className="flex grid-cols-1 gap-2"
        >
            <h2 className="w-[10rem] text-v-sm leading-v-body shrink-0">
                {getTranslatedField({ field: field, middle: 'title', locale })}
            </h2>
            <div className="[&>*]:text-v-sm shrink">
                {parse(
                    getTranslatedField({
                        field: field,
                        middle: 'content',
                        locale
                    })
                )}
            </div>
        </div>
    )
}

const MobileSection = ({ field, locale, index }: CareerFieldProps) => {
    const styles = {
        common: 'w-[80%] h-[1px] bg-v-navy absolute top-1/2 left-1/2 -translate-x-1/2 transition-all duration-300'
    }
    return (
        <div className="accordion-item border-b border-v-gray">
            <input
                id={`accordion-trigger-${index}`}
                className="accordion-trigger-input"
                type="checkbox"
            />
            <label
                className="accordion-trigger flex justify-between items-center relative z-1 cursor-pointer text-v-md leading-v-body shrink-0 py-8 pl-1 pr-4"
                htmlFor={`accordion-trigger-${index}`}
            >
                <span className="leading-none">
                    {getTranslatedField({
                        field: field,
                        middle: 'title',
                        locale
                    })}
                </span>

                <div className="duration-300 w-[1.5rem] h-[1.5rem] relative inline-block group">
                    <span className={clsx(styles.common, 'rotate-[90deg]')} />
                    <span className={clsx(styles.common, 'origin-center')} />
                </div>
            </label>
            <section className="accordion-animation-wrapper">
                <div className="accordion-animation">
                    <div className="accordion-transform-wrapper">
                        <div className="m-0 pb-4 [&>*]:text-v-sm shrink">
                            {parse(
                                getTranslatedField({
                                    field: field,
                                    middle: 'content',
                                    locale
                                })
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export const CareerField = (props: CareerFieldProps) => {
    const isWideScreen = useWindowSize()
    return (
        <Section as="div" width="full">
            {isWideScreen ? (
                <DesktopSection {...props} />
            ) : (
                <MobileSection {...props} />
            )}
        </Section>
    )
}
